export default "https://cdn-static.gokick.com/assets/d05c895b658955f243e3d6e9c630166e56cf3faa/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";